import BaseObjectDirective from './BaseObjectDirective';

function adjustImageSrc(htmlContent) {
    var imgRegex = /<img[^>]*src="\/media\/[a-f0-9-]+\/([a-f0-9-]+\.(?:png|jpg|jpeg|gif))"[^>]*>/gi;
    var matches = htmlContent.matchAll(imgRegex);

    for (const match of matches) {
        var originalTag = match[0];
        var originalSrc = match[0].match(/src="([^"]*)"/)[1];
        var filename = originalSrc.split('/').pop();
        var newSrc = "/media/" + filename;
        var newTag = originalTag.replace(originalSrc, newSrc);
        htmlContent = htmlContent.replace(originalTag, newTag);
    }

    return htmlContent;
}

/**
 * AsfTextObjectNewCtrl is a controller class that extends BaseObjectDirective.
 * It handles the initialization and manipulation of text objects within the application.
 */
export class AsfTextObjectNewCtrl extends BaseObjectDirective {
    /**
     * Constructor for AsfTextObjectNewCtrl.
     */
    constructor($injector, $scope, $rootScope, $signals, $interval, $timeout, TableObjectAPIService, TaskDataService, $routeParams, $config) {
        super($injector, $scope);

        this.$injector = $injector;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$signals = $signals;
        this.$interval = $interval;
        this.$timeout = $timeout;
        this.TableObjectAPIService = TableObjectAPIService;
        this.TaskDataService = TaskDataService;
        this.$routeParams = $routeParams;
        this.$config = $config;

        this.$scope.isTextWithInputObj = this.$scope.contentObject.getObjectType() === 'text-new';

        const TaskInfoService = this.$injector.get('TaskInfoService');
        const taskInfo = TaskInfoService.getTaskInfo();
        const assessmentLanguage = taskInfo.getLanguageCode();

        this.$scope.writingDirection = this.$rootScope.isJournal ? "ltr" : taskInfo.getInputLanguage().writingDirection;
        this.$scope.langISO = taskInfo.getISOInputLanguageCode();
        this.$scope.isCMSandPreview = this.$rootScope.isCMS || this.$rootScope.isPreview;

        const isPDFMode = this.$config.isPDFMode();
        const savedContent = this.$scope.isCMSandPreview ?
            this.$scope.contentObject.getContent() :
            adjustImageSrc(this.$scope.contentObject.getContent());

        this.$scope.contentObject.setContent(savedContent);

        if (this.$scope.isTextWithInputObj) {
            this.initializeTextObject(isPDFMode, taskInfo);
        }

        const frontendMode = !isCMS || this.$rootScope.isPreview;
        this.$scope.isCMS = this.$rootScope.isCMS;
        this.$scope.editMode = false;

        if (!frontendMode) {
            this.$scope.prefsMode = false;
            this.$scope.hasEditMode = true;
        }

        // Sanity check
        if ((typeof this.$scope.contentObject === 'undefined') || this.$scope.contentObject === null) {
            return;
        }

        // Read some basic stuff
        this.$scope.objectUUID = this.$scope.contentObject.getUUID();
        this.$scope.taskuuid = this.$routeParams.taskUUID;
        window.contentObject = this.$scope.contentObject;
        const taskContext = this.TaskDataService.fetchContext();

        if (frontendMode) {
            return;
        }

        this.initPreferences();

        // Remove keydown handler
        angular.element(document).off('keydown');

        // Add resetChanges handler
        this.$scope.resetChanges = () => {
            const elementWithId = angular.element(document.getElementById(this.$scope.contentObject.getUUID() + '_ck5'));
            const ckEditorEditableInline = elementWithId[0].nextSibling;
            const editorInstance = ckEditorEditableInline.querySelector('.ck-editor__editable').ckeditorInstance;
            editorInstance.setData('');
            this.$scope.contentObject.setContent('');
        };

        // Initialize rteModel with content
        this.$scope.rteModel = this.$scope.contentObject.getContent();

        // Add content change handler
        this.$scope.onEditorCallback = (e) => {
            if (this.$scope.editMode) {
                this.$scope.contentObject.setContent(e.value);
                this.$scope.rteModel = e.value;
            }
        };
    }

    initializeTextObject(isPDFMode, taskInfo) {
        if (this.$scope.isTextWithInputObj) {
            let html = $.parseHTML(this.$scope.contentObject.getContent());
            let isUpdated = false;

            // Process input elements
            $(html).find('input').each((index, element) => {
                isUpdated = this.processInputElement(element, isPDFMode) || isUpdated;
            });

            // Process select elements
            if (!this.$rootScope.isJournal && isPDFMode) {
                isUpdated = this.processSelectElements(html, isUpdated);
            }

            if (isUpdated) {
                const htmlContent = $(html).map((idx) =>
                    $($(html).get(idx)).prop('outerHTML')).get().join('');
                this.$scope.contentObject.setContent(htmlContent);
            }
        }
    }

    processInputElement(element, isPDFMode) {
        let isUpdated = false;
        const attributes = {
            'autocomplete': 'off',
            'autocorrect': 'off',
            'autocapitalize': 'off',
            'spellcheck': false
        };

        Object.entries(attributes).forEach(([attr, value]) => {
            if (typeof $(element).attr(attr) === 'undefined') {
                $(element).attr(attr, value);
                isUpdated = true;
            }
        });

        // Apply language-specific font styles
        if (!this.$rootScope.isJournal && isPDFMode) {
            if (this.$scope.langISO === "ar_AR") {
                this.amendArabicFontStyle(element);
                isUpdated = true;
            } else if (this.$scope.langISO === "hi_HI") {
                this.amendHindiFontStyle(element);
                isUpdated = true;
            }
        }

        return isUpdated;
    }

    amendArabicFontStyle(element) {
        $(element).addClass("arabic-pdf-font");
        return element;
    }

    amendHindiFontStyle(element) {
        $(element).addClass("hindi-pdf-font");
        return element;
    }

    amendUrduFontStyle(element) {
        $(element).addClass("urdu-font-force");
        return element;
    }

    processSelectElements(html, isUpdated) {
        let updated = isUpdated;

        if (!this.$rootScope.isJournal && this.$scope.langISO === "ar_AR") {
            $(html).find('select').each((index, element) => {
                this.amendArabicFontStyle(element);
                updated = true;
            });
        }

        if (!this.$rootScope.isJournal && this.$scope.langISO === "ur_UR") {
            $(html).find('select').each((index, element) => {
                this.amendUrduFontStyle(element);
                updated = true;
            });
        }

        if (!this.$rootScope.isJournal && this.$scope.langISO === "hi_HI") {
            $(html).find('select').each((index, element) => {
                this.amendHindiFontStyle(element);
                updated = true;
            });
        }

        return updated;
    }

    initPreferences() {
        function getPreferencesOrDefault(preferencesKey, defaultValue) {
            var preferences = this.$scope.contentObject.getPreferences();
            if (typeof preferences !== "undefined" && preferences.hasOwnProperty(preferencesKey)) {
                return preferences[preferencesKey];
            } else {
                return defaultValue;
            }
        }

        var includedInPDF = getPreferencesOrDefault('includedInPDF', true);

        this.$scope.$watch('preferencesValues', function (val1, val2) {
            if (val1 === val2)
                return;
            var preferences = {};
            angular.forEach(this.$scope.preferencesValues, function (value, key) {
                preferences[key] = value;
            });
            this.$scope.contentObject.setPreferences(preferences);
        }, true);

        this.$scope.preferencesValues = {};
        this.$scope.preferencesValues['includedInPDF'] = typeof includedInPDF !== 'undefined' ? includedInPDF : true;

        this.$scope.preferences = [
            {
                'includedInPDF': [
                    { 'type': 'checkbox', 'name': 'Included in Response PDF', 'valueKey': 'includedInPDF' }
                ],
            }
        ];
    }
}

/**
 * Registers the asfTextNewObject directive.
 */
export function registerAsfTextObjectNewDirective(module) {
    // Register the content object
    module.run(['ContentObjectRegistryService', function (ContentObjectRegistryService) {
        var obj = [{
            "uuid": "",
            "content": "",
            "objectType": "text-new",
            "type": "contentObject",
            "entity_content": {
                "content": "",
                "preferences": {}
            },
            "preferences": {
                "includedInPDF": false
            }
        }];
        var objProperties = {
            type: "text-new",
            label: 'CMS.LAYOUT-MANAGER.NEW-OBJECT.TEXT-CK5.LABEL',
            cssClass: "new-text-object",
            icon: "cms/icon-text-object.png",
            description: 'CMS.LAYOUT-MANAGER.NEW-OBJECT.TEXT-CK5.DESCRIPTION',
            group: {
                id: 1
            }
        };
        ContentObjectRegistryService.register(obj, objProperties);
    }]);

    // Register the directive
    module.directive('asfTextNewObject', ['$compile', '$bridges', '$config', 'TaskDataService', '$rootScope', '$interval', '$http', '$signals',
        function ($compile, $bridges, $config, TaskDataService, $rootScope, $interval, $http, $signals) {
            return {
                restrict: 'EA',
                replace: true,
                scope: {
                    "contentObject": "="
                },
                templateUrl: "/views/ib/contentobjects/textCMS-CK5.html",
                controller: ['$injector', '$scope', '$rootScope', '$signals', '$interval', '$timeout', 'TableObjectAPIService', 'TaskDataService', '$routeParams', '$config', AsfTextObjectNewCtrl],
                link: function ($scope, element, attrs, controller) {
                    $scope.editMode = false;
                    $scope.toggleEditMode = function () {
                        $scope.editMode = !$scope.editMode;
                        if ($scope.editMode) {
                            $scope.rteModel = $scope.contentObject.getContent();
                        }
                    };
                }
            };
        }
    ]);

    module.directive('ck5Tooltip', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var tooltipBox = null;

                function getDirectionForTarget(target) {
                   try {
                        var dir = window.getComputedStyle(target).direction;
                        if (dir === 'rtl' || dir === 'ltr') return dir;
                    } catch (e) {
                        // ignore
                    }
                    if (scope && (scope.writingDirection === 'rtl' || scope.writingDirection === 'ltr')) {
                        return scope.writingDirection;
                    }
                    return 'auto';
                }

                function showTooltip(target, text) {
                    hideTooltip();
                    tooltipBox = document.createElement('div');
                    tooltipBox.className = 'ck5-tooltip-box';
                    tooltipBox.textContent = text;
                    var dir = getDirectionForTarget(target);
                    tooltipBox.dir = dir;
                    tooltipBox.style.textAlign = dir === 'rtl' ? 'right' : 'left';
                    document.body.appendChild(tooltipBox);
                    var currentTooltip = tooltipBox;
                    requestAnimationFrame(function () {
                        if (currentTooltip && currentTooltip === tooltipBox) {
                            positionTooltip(target, currentTooltip);
                        }
                    });
                }

                function hideTooltip() {
                    if (tooltipBox) {
                        tooltipBox.remove();
                        tooltipBox = null;
                    }
                }

                function positionTooltip(target, tooltip) {
                    var targetRect = target.getBoundingClientRect();
                    var tooltipRect = tooltip.getBoundingClientRect();
                    var spacing = 5;

                    var top = targetRect.top - tooltipRect.height - spacing;
                    var left = targetRect.left + (targetRect.width / 2) - (tooltipRect.width / 2);

                    if (top < 0) {
                        top = targetRect.bottom + spacing;
                    }

                    if (left < 0) {
                        left = 5;
                    }

                    if (left + tooltipRect.width > window.innerWidth) {
                        left = window.innerWidth - tooltipRect.width - 5;
                    }

                    tooltip.style.top = (top + window.scrollY) + 'px';
                    tooltip.style.left = (left + window.scrollX) + 'px';
                }

                // Native event delegation
                element[0].addEventListener('mouseover', function (e) {
                    var target = e.target.closest('.ck5-tooltip');
                    if (target) {
                        var text = target.getAttribute('data');
                        if (text) {
                            showTooltip(target, text);
                        }
                    }
                });

                element[0].addEventListener('mouseout', function (e) {
                    var target = e.target.closest('.ck5-tooltip');
                    if (target) {
                        var relatedTarget = e.relatedTarget;
                        if (!relatedTarget || !target.contains(relatedTarget)) {
                            hideTooltip();
                        }
                    }
                });

                var scrollHandler = function () {
                    hideTooltip();
                };
                document.addEventListener('scroll', scrollHandler, true); // Capture phase for better scroll detection

                scope.$on('$destroy', function () {
                    hideTooltip();
                    document.removeEventListener('scroll', scrollHandler, true);
                });
            }
        };
    });
}
